// 制作実績の見出しを、固定ロゴの下へ2vw空けて表示する。
export function initProcessExit(link, target, brand, lenis, reducedMotion, { scroller, viewport = window, followingSection }) {
  const onClick = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    // Lenisの共通アンカー処理による、移動先の上書きを防ぐ。
    event.stopPropagation();
    const targetTop = target.getBoundingClientRect().top;
    // 固定中の見出しの現在位置ではなく、横移動区間を抜けた後の位置へ進む。
    const settledTop = followingSection
      ? followingSection.getBoundingClientRect().top - (target.closest('.section-head').getBoundingClientRect().bottom - targetTop)
      : targetTop;
    const destination = scroller.scrollTop + settledTop
      - brand.getBoundingClientRect().bottom - viewport.innerWidth * .02;
    // 数値で渡し、スクロール枠のscroll-paddingによる二重の余白を避ける。
    lenis.scrollTo(Math.max(0, destination), { duration: 1, immediate: reducedMotion.matches });
  };
  link.addEventListener('click', onClick);
  return () => link.removeEventListener('click', onClick);
}
